import axios from "axios";

const getDynamicValueFromURL = () => {
  const url = typeof window !== "undefined" ? window.location.href : "";
  const tenantName = url.split("/")[2]?.split(":")[0].split(".")[0];
  return tenantName === "localhost" || tenantName === "app"
    ? "stage"
    : tenantName || "stage";
};

const axiosInstance = axios.create({
  baseURL: "",
  headers: {
    "x-tenant-name": getDynamicValueFromURL(),
  },
});

// Request interceptor to update Authorization header with the latest token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // /api/login/mfa/verify returns 401 for a wrong code too (not just an
    // expired/invalid session) - let MfaChallengeForm handle that itself
    // instead of this global handler hijacking it into a redirect before
    // the user even sees the "incorrect code" message.
    const isMfaVerify = error?.config?.url?.includes("/api/login/mfa/verify");
    if (error?.response?.status === 401 && !isMfaVerify) {
      window.location.href = "/#/auth/login?logout=true";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
